import PropTypes from 'prop-types';
import React from 'react';
import { MicroAppLoader } from '../biz-components/micro-app-loader';
import StepDone from '../biz-components/step-done';
import { getStateTaxEntry } from '../tax-form-utils';

function RemoteStateTaxV0(props) {
  const {
    processData,
    company,
    action,
    onSignedSuccess,
    viewResultAsManager,
  } = props;

  if (viewResultAsManager) {
    return (
      <StepDone text="This step has been completed." />
    );
  }

  const env = process.env.DEPLOY_ENV;

  return (
    <MicroAppLoader
      name="state-tax-withholding-v0"
      // entry="http://192.168.31.106:8016"
      entry={getStateTaxEntry(env).v0}
      componentProps={{
        employeeId: (processData || {}).employee_record_uuid,
        triggerId: ((action || {}).us_state_tax_form_submission || {}).digest_key,
        coreCompanyId: (company || {}).uuid,
        env,
        onSignedSuccess,
      }}
    />
  );
}

RemoteStateTaxV0.defaultProps = {
  viewResultAsManager: false,
};

RemoteStateTaxV0.propTypes = {
  company: PropTypes.shape().isRequired,
  processData: PropTypes.shape().isRequired,
  action: PropTypes.shape().isRequired,
  onSignedSuccess: PropTypes.func.isRequired,
  viewResultAsManager: PropTypes.bool,
};

export default RemoteStateTaxV0;
